import * as actions from './updateProfileInfoActions';

const updateProfileInfoReducers = {
  [actions.USER_UPDATE_PROFILE_INFO]: (state, { payload }) => {
    if (payload.userEmail) state.userEmail = payload.userEmail;

    state.profile = {
      ...state.profile,
      ...payload,
    };

    return state;
  },
};

export default updateProfileInfoReducers;
